<template>
 <div class="conversion-box">
   <div class="conversion">
    <div class="top">
      <el-form :model="formData" @submit.native.prevent label-width="70px" label-position="left"> 
        <FormItemComp :formState="root"/>
      </el-form>
      <!-- <div class="tip">
        <svg-icon icon-class='tip' class-name='tip-icon' />
        您可点击更新按钮进行获取最新的转化名称,如果没有更新到最新的转化名称，请联系相关人员
        <UpdateTimeButton 
          type="primary" 
          plain 
          :date="updateTime"
          size="mini"
          @click="handleUpdateNameList"
       />
      </div> -->
      <el-button type="primary" size="mini" @click="handleAddFormClick">+添加出价</el-button>
    </div>
    <div class="form-box" 
      id="infinite-form-box"
      v-loading="loading"
    >
		<ConversionForm 
			v-for="(item, index) in currentFormData" 
			:key="item.id + index" :formData="item" 
			:index="index + 1"
		/>
    </div>
    <div class="footer">
      <el-button @click="handleCloseClick">取消</el-button>
      <el-button type="primary" @keydown.enter.native.prevent @click="onSubmit" :loading="saveLoaing">保存</el-button>
    </div>
  </div>
 </div>
</template>

<script>
import { 
	 updateConversionNameListApi,getFloorPriceApi,
	getDeepConversionNameApi, getConversionPriceApi
 } from '@/api'
import UpdateTimeButton from '@/components/UpdateTimeButton'
import FormItemComp from '@/views/marketingManagement/configuration/formItemComp.vue'
import { createFormItemFactory, observableMap } from './create.js'
import ConversionForm from './conversionForm/index.vue'
import { ADD_TYPE } from '../../constant.js'
import { tipModal } from '../index.js'
import _ from 'lodash'
const defaultFormData = {
	way: '', // 出价方式
	price: '', // 出价
	deep: false, // 深度转化
	powerful: false, // 增强效果
	target: '', // 转化目标
	cost: '', // 期望转化成本
	deepCost: '', // 深度转化出价
	deepTarget: '', // 深度转化目标
	powerfulName:'', // 增强转化目标
	coef_low: '', // 调价系数下限
	coef_tall: '', // 调价系数上限
}
export default {
	props: [ 'cbs', 'displayType', 'appList', 'config', 'account', 'configOpt', 'defaultSelectData','addType' ],
	components: { UpdateTimeButton, FormItemComp, ConversionForm },
	directives: {  },
	provide() {
		return {
			global: this,
		}
	},
	data() {
		const displayTypeMap = observableMap(this.displayType, (item)=> ({...item,num: 0,}))
		const appListMap = observableMap(this.appList, (item)=> ({...item,num: 0,}));
		const selectData = this.defaultSelectData || {};
		const addType = this.addType || ADD_TYPE.POSITION;
		return {
			defaultFormData: _.cloneDeep(defaultFormData),
			displayTypeMap,
			appListMap,
			updateTime: 0,
			formData: {},
			loading: false,
			saveLoaing: false,
			targetList: [],
			selectData,
			currentKey: '',
			currentAddType: addType,
			priceTypeList: [],//出价类型
			conversionNameList: {},//转化名称列表
			// currentFormData: [],
			cacheAvgPrice: new Map(),//缓存平均出价
			cacheDeepConversionName: {},//缓存深度转化名称列表
			floorPrice: null,//最低出价
			currentFloorPrice:{},//当前最低出价
		}
	},
	computed: {
		isPosition() {
			return this.currentAddType ===ADD_TYPE.POSITION
		},
		currentFormData() {
			return this.selectData[this.currentKey] || [];
		},
		root() {
			return createFormItemFactory({ 
				displayType:  this.displayTypeMap,
				appList: this.appListMap, 
				vm: this
			})
		},
		appId() {
			if(this.isPosition) {
				return '';
			}
			const [ app_id ] = this.currentKey.split('_');
			return app_id;
		}
	},
	watch: {
	
	},
	created() {
		
	},
	mounted() {},
	methods: {
		 async formDataChange(acients, formData) {
			const key = _.tail(acients).map(v=>v.payload.value).join('_');
			if(!this.floorPrice) {
				await this.getFloorPrice();
			}
			// 防止重复渲染
			if(this.currentKey === key) {
				return;
			}
			this.currentFloorPrice = this.floorPrice.find(v=>v.ad_placement_id === _.last(acients).payload.value);
			console.log('出价信息', this.currentFloorPrice);
			this.currentKey = key;
			this.formData = formData;
			const price_type = this.config.pay_type;
			const conv_type = this.config.conv_type;
			
			const keyDisplayType = _.keyBy(this.displayType, 'value')
			const priceTypeList = _.filter(price_type, { pid: keyDisplayType[formData.display_type].param_id  });
			const convTypeList = _.filter(conv_type, { pid: keyDisplayType[formData.display_type].param_id  });
			this.priceTypeList = priceTypeList;
			this.conversionNameList = convTypeList;
			// this.priceTypeList = price_type;
			if(!this.selectData[key]) {
				this.$set(this.selectData, key, [{ ..._.cloneDeep(defaultFormData), id: _.uniqueId() }]);
			}
			// this.currentFormData = this.selectData[key];
			this.currentAddType = _.head(acients).payload.value;
			if(this.currentAddType === ADD_TYPE.POSITION) {
				
			}
			// console.log(acients, key, targetList,formData, 'formDataformDataformData');
			this.updateFormOptionData()
		},
		updateFormOptionData() {
			const isP = this.currentAddType ===ADD_TYPE.POSITION;
			const [ app_id ] = this.currentKey.split('_');
			
			_.forEach(this.displayTypeMap, (item)=> {
				const data = this.selectData[ isP? `${item.value}` : `${app_id}_${item.value}` ];
				item.num =  data?.length || 1;
			});
			if (isP) {
				_.forEach(this.appListMap, (item)=>{
					item.num =   1;
				});
			}else {
				_.forEach(this.appListMap, (item)=>{
					item.num =  _.sumBy(this.displayTypeMap, (v)=> {
						const data = this.selectData[`${item.value}_${v.value}`];
						if (data) {
							return data.length;
						}else {
							return 1;
						}
					});
				});
			}
		},
		// 添加方式切换
		handleAddTypeBeforeChange({ newValue, oldValue }) {
			return new Promise((resolve, reject) => {
				this.$confirm('切换后已经修改的内容不会保存，确认要切换吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.selectData = {};
					this.updateFormOptionData()
					resolve()
				}).catch(reject);
			})
		},
		// 添加
		handleAddFormClick() {
			this.selectData[this.currentKey].push({ ..._.cloneDeep(defaultFormData), id: _.uniqueId() });
			this.updateFormOptionData()
		},
		
		
		onSubmit() {
			const keys = Object.keys(this.selectData);
			const ERROR_TYPE = {
				EMPTY: '1', // 没有填写的出价信息
				DUPLICATE: '2', // 存在相同的出价信息
				NOT_VALID: '3', // 出价信息不合法
			};
			const ERROR_TYPE_LIST = {
				[ERROR_TYPE.EMPTY]: [],
				[ERROR_TYPE.DUPLICATE]: [],
				[ERROR_TYPE.NOT_VALID]: [],
			};
			const displayTypeMap = _.mapValues(_.keyBy(this.displayType, 'value'), 'label');
			const appListMap = _.mapValues(_.keyBy(this.appList, 'value'), 'app_name');
			const keysAllValid = keys.reduce((pre,key)=> {
				const data = this.selectData[key];
				const checkData = {};
				const list =data.map((item, index)=>{
					const validItem  = this.validateFormDataItem(item, key, ERROR_TYPE);
					if(validItem) {
						return validItem;
					}
					 const omitIData = _.omit(item, 'id');
					 const dataKey = JSON.stringify(omitIData);
					 if(checkData[dataKey]) {
						 return ERROR_TYPE.DUPLICATE;
					 }
					 checkData[dataKey] = true;
					return null;
				});
				pre[key] = list
				return pre
			}, {});
			Object.keys(keysAllValid).forEach(key=> {
				const list = keysAllValid[key];
				list.forEach((item, index)=> {
					if(item) {
						let message = '';
						const [ app_id, display_type ] = key.split('_');
						if(this.isPosition) {
							message = displayTypeMap[app_id]
						}else {
							message = `${appListMap[app_id]}_${displayTypeMap[display_type]}`;
						}
						ERROR_TYPE_LIST[item].push(`${message}_第${index + 1}条`);
					}
				})
			});
			console.log(ERROR_TYPE_LIST, 'ERROR_TYPE_LIST');
			!(()=> {
				if(this.isPosition) {
					_.forEach(this.displayTypeMap, (item)=> {
						const data = this.selectData[item.value];
						if (!(data && data.length)) {
							ERROR_TYPE_LIST[ERROR_TYPE.EMPTY].push(`${item.label}_第1条`);
						}
					});
				}else {
					_.forEach(this.appListMap, (item)=> {
						_.forEach(this.displayTypeMap, (v)=> {
							const data = this.selectData[`${item.value}_${v.value}`];
							if (!(data && data.length)) {
								ERROR_TYPE_LIST[ERROR_TYPE.EMPTY].push(`${item.app_name}_${v.label}_第1条`);
							}
						})
						
					})
				}
			}) ();
			if(_.values(ERROR_TYPE_LIST).some(v=>v.length) ) {
				tipModal({
					props: {
						tip: '',
						list: _.omitBy({
							'存在相同的出价信息': ERROR_TYPE_LIST[ERROR_TYPE.DUPLICATE],
							'没有填写的出价信息': ERROR_TYPE_LIST[ERROR_TYPE.EMPTY],
							'出价信息不合法': ERROR_TYPE_LIST[ERROR_TYPE.NOT_VALID],
						}, (v)=> !v.length),
					}
				})
				return;
			}
			this.cbs.onSubmit(this.selectData, this.currentAddType)
		},
		// 验证出价数据
		validateFormDataItem(item, key, ERROR_TYPE) {
			const { way, price,deep, powerful, target, cost, deepCost , deepTarget,
				powerfulName, coef_low, coef_tall,
			} = item;
			
			if(!way) {
				return ERROR_TYPE.EMPTY;
			}

			let display_type = key;
			if(!this.isPosition) {
				display_type = _.last(key.split('_'));
			}
			// 处理最低出价的情况
			const price_type = this.config.pay_type;
			const keyDisplayType = _.keyBy(this.displayType, 'value')
			console.log(keyDisplayType, display_type, 'wwwwww');
			const priceTypeList = _.filter(price_type, { pid: keyDisplayType[display_type].param_id  });
			
			const data = _.mapValues(_.keyBy(priceTypeList, 'value'), (v)=> _.toLower(v.label))
			
			const currentFloorPrice = this.floorPrice.find(v=>v.ad_placement_id === display_type);
			const floor_price = currentFloorPrice.floor_price;
			// 一阶出价
			if(!price || floor_price[`${data[way]}_floor_price`] > price) {
				return ERROR_TYPE.NOT_VALID;
			}
			const conversion_price = currentFloorPrice.conversion_price;
			const convTypeData = _.keyBy(conversion_price, 'conv_type');
			// 二阶出价
			if(['2', '4'].includes(way)) {
				
				if( !target || !cost || convTypeData[target][`${data[way]}_floor_price`] > cost) {
					return ERROR_TYPE.NOT_VALID;
				}
			}
			// 三阶出价
			if(deep) {
				console.log(deepTarget, convTypeData, data, way, 'wwwwww');
				if(!deepCost ||!deepTarget || convTypeData[deepTarget][`${data[way]}_floor_price`] > deepCost) {
					return ERROR_TYPE.NOT_VALID;
				}
			}
			// 增强
			if(powerful) {
				if(!powerfulName ||!coef_low ||!coef_tall || !(+coef_low >= 0.2 && +coef_low <= 1) ||!(+coef_tall >= 1 && +coef_tall <= 5)) {
					return ERROR_TYPE.NOT_VALID;
				}
			}
			return null;
		},
		// 关闭逻辑
		handleCloseClick() {
			this.$emit('close')
		},
		
		async handleUpdateNameList() {
			const vm = this.$notify({
				title: '请求成功',
				message: '正在更新，请稍等',
				type: 'success'
			});
			const params = {
				account_id: this.account,
				plat_id: 11,
				product_id: this.displayType.map(v=> v.value),
			}
			try {
			await updateConversionNameListApi(params);
			// this.$bus.$emit('updateName')
			this.$notify({
				title: '更新成功',
				message: '转化跟踪 更新成功',
				type: 'success'
			});
			} catch (error) {
			if (typeof error.data === "number" && error.data>0) {
				this.updateTime = error.data;
			}
			this.$notify({
				title: '更新失败',
				message: error.info || '更新失败',
				type: 'error'
			});
			console.log('转化名称更新失败',error);
			}
			if (vm) {
			vm.close()
			}
		},
		handleDelClick(id) {
			const list = this.selectData[this.currentKey];
			if (list.length <=1) {
				this.$message.error('至少需要一个出价');
				return;
			};
			const  index = _.findIndex(list, (item)=> item.id === id);
			if (index > -1) {
				list.splice(index, 1);
				this.updateFormOptionData()
			}
		},
		handleCopyClick(formData) {
			this.selectData[this.currentKey].push({
				...formData,
				id: _.uniqueId(),
			});
			this.updateFormOptionData()
		},
		// 出价均值
		async getBatchConversionPrice(query = {}) {
			const params = {
				account_id: this.account,
				plat_id: 11,
				ad_placement_id: this.formData.display_type,
				product_id: this.appList.map(v=> v.value),
				...query
			};
			const mapKey = JSON.stringify(params);
			if(this.cacheAvgPrice.has(mapKey)){
				return this.cacheAvgPrice.get(mapKey);
			}
			const { data } = await getConversionPriceApi(params);
			this.cacheAvgPrice.set(mapKey, data.list);
			return data.list;
		},
		async getDeepConversionName(query = {}) {
			const params = {
				account_id: this.account,
				plat_id: 11,
				...query
			}
			const mapKey = JSON.stringify(params.tracking_id);
			if(this.cacheDeepConversionName[mapKey]){
				return this.cacheDeepConversionName[mapKey];
			};
			this.$set(this.cacheDeepConversionName, mapKey, []);
			const { data } = await getDeepConversionNameApi(params);
			if (!data?.length ) {
				this.$set(this.cacheDeepConversionName, mapKey, null);
				return [];
			}
			this.$set(this.cacheDeepConversionName, mapKey, data);
		},
		handleValidNumber(num) {
			const value = num+'';
			if (value.indexOf('.')>-1) {
				const list = value.split('.');
				if (list[1].length>2) {
				return [list[0], list[1].slice(0,2)].join('.')
				}
			}
		},
		// 获取最低出价
		async getFloorPrice() {
			const params = {
				plat_id: 11,
				ad_placement_id: this.displayType.map(v=> v.value),
			}
			const { data } = await getFloorPriceApi(params);
			this.floorPrice = data.list
		}
	}
}
</script>

<style lang="scss" scoped>
.tip-icon {
  font-size: 18px;
  margin-right: 4px;
}
.conversion-box {
  height: 100%;
  width: 100%;
  overflow-x: auto;
}
.conversion {
  padding: 0 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 1200px;
  .tip {
    margin-bottom: 10px;
  }
  .form-box {
    height: 0;
    flex: 1;
    overflow: auto;
    // background: red;
    margin-top: 16px;
  }
  .footer {
    height: 60px;
    line-height: 60px;
    text-align: right;
    padding-right: 80px;
    margin: 0 -20px;
    box-shadow: 4px 0 4px #ccc;
  }
}

</style>